<template>
  <div class="111">
    <h1>{{ msg }}</h1>

    <div class="con">
      <table style="margin: 8px auto; width:450px;">
        <tr>
          <td>
            <h2 style="display:inline;"><router-link to="/keyboard">键位练习</router-link></h2>
            <h2 style="display:inline;"><router-link to="/keyboardEN">英文打字练习</router-link></h2>
            <h2 style="display:inline;"><router-link to="/keyboardCN">中文打字练习</router-link></h2>
          </td>
        </tr>
      </table>
    </div>


    <div class="foot">
      <div class="miitbeian">
        <a href="https://beian.miit.gov.cn/">
          鄂ICP备2021006407号-2
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      msg: '网站建设中，敬请期待'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.con a {
  color: #42b983;
  text-decoration: underline;
}
.foot a {
  color: #333;
}
.foot a:hover {
  color: #42b983;
}
.foot {
  width: 100%;
  height: 60px;
  line-height: 60px;
  position: fixed;
  bottom: 0;
  background-color: #f1f1f1;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue